module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  if(typeof title !== 'undefined' && title !== null && title !== ''){ 
    ; __append("\n    <div class=\"header\">")
    ; __append(escapeFn( title ))
    ; __append("</div>\n")
    ;  } 
    ; __append("\n\n<div class=\"show-browse-grid grid portrait ")
    ;  if(typeof title !== 'undefined' && title !== null && title === 'Trending'){ 
    ; __append("trending")
    ;  } 
    ; __append("\">\n\n</div>\n")
  }
  return __output;

}